import { useMemo } from 'react';
import { CustomScalarSpreadsheet } from 'components';
import { BacksolveTableProps } from './types';

const BacksolveTable = ({
  deleteColFn,
  format,
  isLedgerTable,
  isLoading,
  onChange,
  spreadsheets,
  workbook,
}: BacksolveTableProps) => {
  const { backsolveSheet } = spreadsheets;

  const perShareFormat = useMemo(
    () => (format ? { ...format, currency: { ...format.currency, units: '' } } : format),
    [format]
  );

  const backsolveSheetProps = useMemo(
    () => ({
      ...backsolveSheet,
      id: 'backsolve-table',
      tableTerms: { tableSlug: 'backsolve-table' },
      workbook,
      onChange,
      sheet: backsolveSheet,
      displayLegend: false,
      alwaysDisplayLegend: false,
      format: perShareFormat,
      deleteColumn: deleteColFn,
      isLedgerTable,
    }),
    [backsolveSheet, deleteColFn, perShareFormat, isLedgerTable, onChange, workbook]
  );

  return (
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore: ScalarSpreadsheet is not typed
    <CustomScalarSpreadsheet {...backsolveSheetProps} isLoading={isLoading} />
  );
};

export default BacksolveTable;
